import { t } from 'ttag';

import { Title } from '@ui/Title';
import { ReviewInCatalog } from '@components/ReviewInCatalog';

import s from './ReviewsInCatalog.sss';

type Buyer = {
  id: number;
  username: string;
};

type Product = {
  id: number;
  name: string;
  thumbnail: string;
  url: string;
};

interface Review {
  id: string,
  buyer: Buyer,
  product?: Product | null,
  updatedAt: string,
  text: string,
  overallRating: number,
}

interface Props {
  reviews: Review[]
}

export const ReviewsInCatalog: React.FC<Props> = ({
  reviews,
}) => {
  if (!reviews.length) {
    return null;
  }

  return (
    <div className={s.root}>
      <Title
        type="h2"
        className={s.title}
      >
        {t`Відгуки`}
      </Title>

      <ul className={s.list}>
        {reviews.map((item) => (
          <li
            key={item.id}
            className={s.item}
          >
            <ReviewInCatalog
              buyer={item.buyer}
              product={item.product}
              updatedAt={item.updatedAt}
              text={item.text}
              overallRating={item.overallRating}
              className={s.reviewsCatalogBlock}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
